<template>
  <div :id="id" class="toastify-content flex" :class="{ hidden: hidden }">
    <CheckCircleIcon class="text-theme-9" />
    <div class="ml-4 mr-4">
      <div class="font-medium">{{ text }}</div>
      <div class="text-gray-600 mt-1"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Message",
  props: {
    id: { type: String, required: true },
    text: { type: String, required: true },
    hidden: { type: Boolean, default: true },
  },
};
</script>
